import {
  Calendar,
  CalendarGrid,
  CalendarGridBody,
  CalendarGridHeader,
  CalendarHeaderCell,
} from "react-aria-components";
import type { CalendarProps, DateValue } from "react-aria-components";
import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

import { CalendarCell2 } from "../atoms/CalendarCell";
import { CalendarHeading } from "../atoms/CalendarHeading";
import { PaginationButton } from "../atoms/PaginationButton";

type Calendar2Props<T extends DateValue> = {
  children?: ReactNode;
  className?: string;
} & CalendarProps<T>;

export function Calendar2<T extends DateValue>({
  children,
  className,
  ...props
}: Calendar2Props<T>) {
  const { footer, grid, header, headerCell, root } = calendarStyles();

  return (
    <div className={cn(root(), className)}>
      <Calendar {...props}>
        <header className={header()}>
          <PaginationButton variant="previous" />

          <CalendarHeading />

          <PaginationButton variant="next" />
        </header>

        <CalendarGrid className={grid()}>
          <CalendarGridHeader>
            {(day) => <CalendarHeaderCell className={headerCell()}>{day}</CalendarHeaderCell>}
          </CalendarGridHeader>

          <CalendarGridBody>{(date) => <CalendarCell2 date={date} />}</CalendarGridBody>
        </CalendarGrid>
      </Calendar>
      {children && <footer className={footer()}>{children}</footer>}
    </div>
  );
}

const calendarStyles = tv({
  slots: {
    footer: "tw:flex tw:items-center tw:justify-between",
    grid: "tw:w-full tw:border-collapse",
    header: "tw:flex tw:items-center tw:pb-3.5",
    headerCell:
      "body-xs tw:leading-4 tw:font-light tw:w-8 tw:text-center! tw:text-xs tw:text-text-secondary",
    root: "tw:flex tw:w-70 tw:flex-col tw:gap-2.5 tw:rounded-lg tw:border tw:border-solid tw:border-fill-senary tw:p-3 tw:shadow-xl",
  },
});
